(function(){
  function tagRevealTargets(){
    var selectors = [
      '.product-item-v1 .product', '.product-item-v2 .product', '.product-item-v3 .product',
      '.product-item-v4 .product', '.product-item-v5 .product', '.product-item-v6 .product',
      '.product-item-v7 .product', '.product-item-v8 .product', '.product-item-v9 .product',
      '.title_heading', '.gp-contact-card', '.gp-trade-cta-inner'
    ];
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        if(!el.classList.contains('gp-reveal')){
          el.classList.add('gp-reveal');
        }
      });
    });
  }
  function initObserver(){
    if(!('IntersectionObserver' in window)){
      document.querySelectorAll('.gp-reveal').forEach(function(el){ el.classList.add('gp-in-view'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('gp-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.gp-reveal:not(.gp-in-view)').forEach(function(el){ observer.observe(el); });
  }
  function run(){
    tagRevealTargets();
    initObserver();
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', function(){
    setTimeout(run, 300);
  });
})();
